<template>
  <div class="content">
    <div class="text">
      <p>广东分级诊疗模式初步形成</p>
      <p>2月28日，广东省卫计委召开全省医政工作会议，会上，省卫计委政务服务中心发布了全省医疗卫生事业发展现状统计数据。笔者从会议上获悉，2016年，广东省县（区）及以下医疗机构门诊、住院量分别占全省的80%、65%，这也意味着，广东省分级诊疗模式初步形成。</p>
      <p>看病有多贵 平均看一次病227元住一次院10924元</p>
      <p>去年，有多少人在广东看病、住院？患者看一次病、住一次院平均要花多少钱？据省卫计委统计，2016年，全省医疗机构总诊疗8.1亿人次，环比增长2.9%；出院1544.6万人次，环比增长7.3%。公立医院次均门诊费用227.7元，较2015年增加7.6%；公立医院次均住院费用10924.0元，较2015年增加6.1%。</p>
      <p>统计显示，目前，我省人均卫生资源不足的现状仍较突出。其中，每千人口医生、护士、医疗床位数虽稳步上升，但均低于全国平均水平。</p>
      <p>2017年，广东将启动全省综合医改，在21个地市实现分级诊疗制度全覆盖。2016年，广东省县（区）及以下医疗机构门诊、住院量分别占全省的80%、65%，医疗服务分布呈金字塔形，分级诊疗模式初步形成。</p>
      <p>“分级诊疗的关键是基层能否提供优质的医疗服务。”省卫计委医政处处长张伟介绍，广东各级财政将投入500亿元提升基层医疗服务能力，加上建设卫生强省的112亿元投入，这些措施将大大提升基层医疗卫生水平。</p>
      <p>药占比逐年下降 城市公立医院改革7月前启动</p>
      <p>张伟透露，据国家安排，今年7月1日前，广东省将全面启动城市公立医院改革，而这也将是今年广东卫生计生事业最为艰巨的任务。</p>
      <p>统计显示，全省公立医院医疗收入总量逐年增长，2016年达1937.6亿元，较上年增长13.3%；平均每家公立医院医疗收入2.7亿元，较上年增长14.3%，其中，药品耗材、检查化验收入普遍成为各医疗机构收入的主要部分，而体现医务人员技术劳务部分的项目如挂号、床位、护理、手术、治疗等收入所占比重较低。</p>
      <p>近年来，公立医院药占比逐年下降。2016年，公立医院药占比下降至34.8%，较去年下降0.9个百分点；但卫生耗材、检查化验占比逐年上升，其中2015年卫生材料收入较2012年增加138.1%，增长幅度及速度远高于其他收入。</p>
      <p>张伟介绍，城市公立医院改革将按照“总量控制、结构调整、有升有降”的原则，降低药品耗材占比、检查化验占比，提升医务人员技术劳务占比。</p>
      <p>“目前医务人员劳务价值被严重扭曲，与之相对的药品占比就高了。”张伟认为，药占比问题应客观评价，“破除以药养医机制，提高医务人员劳务价值，提高诊疗护理床位费，控制减少药品使用，药占比自然就降下来了。”他透露，针对医务人员劳务价值具体如何提高，目前发改部门正在进行相关方面的测算。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabHierarchicalMedical'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  .text{
    p{
      font-size: 18px;
      line-height: 36px;
      text-indent:40px;
    }
  }
}
</style>
